// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { EntitySuggestionsV2_AiSuggestionFragment } from './entitySuggestionsV2.fragments.generated';
import { gql } from '@apollo/client';
import { EntitySuggestionsV2_AiSuggestionFragmentDoc } from './entitySuggestionsV2.fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchEntityAiSuggestionsV2QueryVariables = Types.Exact<{
  entityID: Types.Scalars['ID']['input'];
}>;


export type FetchEntityAiSuggestionsV2Query = { __typename?: 'Query', aiSuggestions: { __typename?: 'AISuggestionConnection', edges?: Array<{ __typename?: 'AISuggestionEdge', node?: (
        { __typename?: 'AISuggestion' }
        & EntitySuggestionsV2_AiSuggestionFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    FetchEntityAISuggestionsV2: 'FetchEntityAISuggestionsV2' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const FetchEntityAiSuggestionsV2Document = gql`
    query FetchEntityAISuggestionsV2($entityID: ID!) {
  aiSuggestions(
    where: {kindIn: [BENEFICIAL_OWNER, BENEFICIARY_V2, KEY_PERSON, PRINCIPAL, SUCCESSOR_TRUSTEE, TRUSTEE, TRUST_ADVISOR, BENEFICIAL_OWNERS_AS_OF_DATE, BUSINESS_ENTITY_TAX_STATUS, CRUMMEY_WITHDRAWAL_PERIOD_DAYS, DOING_BUSINESS_AS_NAME, EFFECTIVE_DATE, FINCEN_ID, JURISDICTION_STATE_CODE, LEGAL_NAME, TAX_ID], hasEntityWith: {id: $entityID}, or: [{version: 2, or: [{acceptanceStatusIsNil: true}, {acceptanceStatus: ACCEPTED}, {acceptanceStatus: AUTO_ACCEPTED}]}, {versionNEQ: 2, or: [{acceptanceStatus: ACCEPTED}, {acceptanceStatus: AUTO_ACCEPTED}]}]}
    orderBy: {field: created_at, direction: DESC}
  ) {
    edges {
      node {
        ...EntitySuggestionsV2_AISuggestion
      }
    }
  }
}
    ${EntitySuggestionsV2_AiSuggestionFragmentDoc}`;

/**
 * __useFetchEntityAiSuggestionsV2Query__
 *
 * To run a query within a React component, call `useFetchEntityAiSuggestionsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useFetchEntityAiSuggestionsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchEntityAiSuggestionsV2Query({
 *   variables: {
 *      entityID: // value for 'entityID'
 *   },
 * });
 */
export function useFetchEntityAiSuggestionsV2Query(baseOptions: Apollo.QueryHookOptions<FetchEntityAiSuggestionsV2Query, FetchEntityAiSuggestionsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchEntityAiSuggestionsV2Query, FetchEntityAiSuggestionsV2QueryVariables>(FetchEntityAiSuggestionsV2Document, withFetchPolicyContext(options));
      }
export function useFetchEntityAiSuggestionsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchEntityAiSuggestionsV2Query, FetchEntityAiSuggestionsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchEntityAiSuggestionsV2Query, FetchEntityAiSuggestionsV2QueryVariables>(FetchEntityAiSuggestionsV2Document, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useFetchEntityAiSuggestionsV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchEntityAiSuggestionsV2Query, FetchEntityAiSuggestionsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchEntityAiSuggestionsV2Query, FetchEntityAiSuggestionsV2QueryVariables>(FetchEntityAiSuggestionsV2Document, withFetchPolicyContext(options));
        }
export type FetchEntityAiSuggestionsV2QueryHookResult = ReturnType<typeof useFetchEntityAiSuggestionsV2Query>;
export type FetchEntityAiSuggestionsV2LazyQueryHookResult = ReturnType<typeof useFetchEntityAiSuggestionsV2LazyQuery>;
export type FetchEntityAiSuggestionsV2SuspenseQueryHookResult = ReturnType<typeof useFetchEntityAiSuggestionsV2SuspenseQuery>;
export type FetchEntityAiSuggestionsV2QueryResult = Apollo.QueryResult<FetchEntityAiSuggestionsV2Query, FetchEntityAiSuggestionsV2QueryVariables>;